import Header from "./Header";
import Viewer from "./Viewer";

const Main = () => {
  return (
    <>
      <Header />
      <Viewer />
    </>
  );
};

export default Main;
